namespace advisorop.components.meetinghub {

    export class MeetingControlsController {
        private meetingHubService: services.MeetingHubService;
        public showController: { controller: domains.MeetingHubControllers };
        createMeetingCallback: any;
        isServicer: boolean;
        isAdvisor: boolean;
        isInvestor: boolean;
        isMeetingAvailabilitySet: boolean;
        meetingDateRange: domains.IMeetingDateRange;
        onDatesChanged: any;

        dbFromDate: DevExpress.ui.dxDateBoxOptions;
        dbToDate: DevExpress.ui.dxDateBoxOptions;


        constructor(private _meetingHubService: services.MeetingHubService) {
            this.meetingHubService = _meetingHubService;

            this.dbFromDate = {
                bindingOptions: {
                    value: 'vm.meetingDateRange.fromDate'
                },
                pickerType: "calendar",
                calendarOptions: {
                    maxZoomLevel: "year",
                    zoomLevel: "year"
                },
                type: "date",
                onValueChanged: e => {
                    this.onFromDateChange(e);
                },
            }

            this.dbToDate = {
                bindingOptions: {
                    value: 'vm.meetingDateRange.toDate'
                },
                pickerType: "calendar",
                calendarOptions: {
                    maxZoomLevel: "year",
                    zoomLevel: "year"
                },
                type: "date",
                onValueChanged: e => {
                    this.onToDateChange(e);
                },
            }

        }

        onFromDateChange(e: object): void {
            console.log(e);
            if (!this.meetingDateRange.updateToDate()) {
                this.onDatesChanged();
            }
        }

        onToDateChange(e: object): void {
            console.log(e);
            if (!this.meetingDateRange.updateFromDate()) {
                this.onDatesChanged();
            }
        }

        updateController(controller: domains.MeetingHubControllers) {
            this.showController.controller = controller;
        }
        onSetCalendarView(): void {
            this.updateController(domains.MeetingHubControllers.CALENDAR);
        }

        onSetListView(): void {
            this.updateController(domains.MeetingHubControllers.MEETING_LIST);
        }

        onSetMeetingAvailability(): void {
            this.updateController(domains.MeetingHubControllers.MEETING_AVAILABILITY_CREATOR);
        }

        onCreateMeeting(): void {
            this.createMeetingCallback();
        }

        $onInit(): void {
        }

        $onChanges(evt) {
            console.log(evt);
        }
    }

    class MeetingControls implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                createMeetingCallback: "&",
                showController: "<",
                isServicer: "<",
                isAdvisor: "<",
                isInvestor: "<",
                meetingDateRange: "<",
                isMeetingAvailabilitySet: "<",
                onDatesChanged: "&"
            };
            this.controller = [`meetingHubService`, MeetingControlsController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/components/meeting-controls.html`;
        }
    }
    angular.module(Constants.APP).component(`meetingControls`, new MeetingControls());

}